<template>
    <footer class="mkt-light" style="padding:40px 0 20px;border-top:1px solid #E2E8F0;">
        <div class="mkt-container">
            <div class="row justify-between items-center">
                <div class="row items-center">
                    <img src="/img/logo-nav.webp" alt="eSign Launchpad" width="82" height="22" style="height: 22px; width: auto;" />
                </div>
                <div class="row q-gutter-md">
                    <a href="/Home/Features" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Features</a>
                    <a href="/Home/Pricing" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Compare plans</a>
                    <a href="/news" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">News</a>
                    <a href="/Home/Security" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Security</a>
                    <a href="/contact" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Contact</a>
                    <a href="/privacy" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Privacy</a>
                    <a href="/terms" class="text-no-decoration" style="font-size:0.8rem;color:#475569;">Terms</a>
                </div>
                <div style="font-size:0.75rem;color:#64748B;">&copy; {{ currentYear }} Evenstar Services, LLC. eSign Launchpad is a registered DBA.</div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'MarketingFooter',
    data() {
        return {
            currentYear: new Date().getFullYear()
        };
    }
};
</script>

<style scoped>
</style>
